import * as styles from "./SelectGroupLabel.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Select as BaseSelect } from "@base-ui/react/select";

import type { SelectGroupLabelProps } from "./Select.types";

export function SelectGroupLabel({
  className,
  ...props
}: SelectGroupLabelProps): JSX.Element {
  return (
    <BaseSelect.GroupLabel
      data-slot="select-group-label"
      className={clsx(styles.groupLabel, className)}
      {...props}
    />
  );
}
